import { Radio } from 'antd'
import classNames from 'classnames'
import { useAtom } from 'jotai'
import { useEffect, useMemo } from 'react'
import { MyForm } from '~/components/ui/MyForm'
import { SuperType } from '~/graphqls/types'
import {
  controlPrefineAtom,
  optionsAtom,
  prefineOriginalPointAtom,
  prefinePointAtom,
} from './atom'
import styles from '../AiForm.module.css'
import { isNullOrUndefined } from '~/utils'
import { observer } from 'mobx-react'
import { useAuth } from '~/hooks/useAuth'

export const PrefineComp = observer(() => {
  const [options] = useAtom(optionsAtom)
  const [, setPrefinePoint] = useAtom(prefinePointAtom)
  const [, setPrefineOriginalPoint] = useAtom(prefineOriginalPointAtom)
  const [controlPrefine, setControlPrefine] = useAtom(controlPrefineAtom)

  const { isHighUser } = useAuth()

  /** controlnet精修options */
  const controlPrefineOptions = useMemo(() => {
    console.log(options!.controlPrefineOption)
    if (!options!.controlPrefineOption?.length) return []

    const controlPrefineOption: {
      label: string
      value: SuperType
      price?: number | undefined
      membersPrice?: number
    }[] = []

    options!.controlPrefineOption.forEach(it => {
      if (it?.superType === SuperType.SUPERSIZE) {
        controlPrefineOption.push({
          label: '不使用精绘',
          value: it.superType,
          price: it?.price || 0,
          membersPrice: it.membersPrice,
        })
      } else {
        controlPrefineOption.push({
          label: '精绘',
          value: it?.superType as SuperType,
          price: it?.price || 0,
          membersPrice: it?.membersPrice,
        })
      }
    })
    return controlPrefineOption
  }, [options!.controlPrefineOption])

  useEffect(() => {
    const curPrefineOptions = controlPrefineOptions?.filter(
      it => it.value === controlPrefine
    )?.[0]

    if (!!curPrefineOptions?.price) {
      let point = curPrefineOptions?.price
      if (isHighUser && !isNullOrUndefined(curPrefineOptions.membersPrice)) {
        point = curPrefineOptions.membersPrice!
      }

      setPrefinePoint(point)
      setPrefineOriginalPoint(curPrefineOptions?.price)
    } else {
      setPrefinePoint(0)
      setPrefineOriginalPoint(0)
    }
  }, [controlPrefineOptions, controlPrefine])

  useEffect(() => {
    if (!controlPrefine) {
      setControlPrefine(controlPrefineOptions?.[0]?.value)
    }
  }, [controlPrefine])

  return (
    <MyForm.Item
      label={
        <>
          <span className="mr-1">* 图像精绘</span>
        </>
      }
      className={styles.borderLessFormItem}
    >
      <Radio.Group
        className={classNames(
          styles.customRadioGroup,
          styles.customPrefineRadio,
          '!mb-8'
        )}
        value={controlPrefine}
        onChange={e => setControlPrefine(e.target.value)}
      >
        {controlPrefineOptions.map(item => {
          return (
            <Radio
              key={item.label}
              value={item.value}
              className={styles.customRadio}
            >
              <div
                className={classNames('radioWrap !rounded-full', {
                  prefine: item.value === SuperType.PREFINE,
                })}
              >
                <div className="bg-neutral-100 rounded-full">
                  <div
                    className={classNames(
                      'flex items-center justify-center cursor-pointer p-2 border-2 border-solid border-neutral-200 rounded-full duration-75 flex-1 text-center text-xs w-full bg-neutral-200'
                    )}
                  >
                    <div className="text-neutral-800 font-semibold">
                      {item.label}
                      {!!item.price &&
                        !isNullOrUndefined(item.membersPrice) &&
                        isHighUser && (
                          <>
                            <span className="text-neutral-500 ml-1">
                              {item.membersPrice}积分/张
                            </span>
                            <span
                              className={classNames(
                                'text-neutral-500 ml-1',
                                styles.delPrice
                              )}
                            >
                              {item.price}积分
                            </span>
                          </>
                        )}
                      {!!item.price &&
                        (isNullOrUndefined(item.membersPrice) ||
                          !isHighUser) && (
                          <span className="text-neutral-500 ml-1">
                            {item.price}积分/张
                          </span>
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </Radio>
          )
        })}
      </Radio.Group>
    </MyForm.Item>
  )
})
